import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step"]
  static values = { startedAt: String, files: Number, questions: Number }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const elapsed = (Date.now() - Date.parse(this.startedAtValue)) / 1000
    const thresholds = this.thresholds()
    this.stepTargets.forEach((step, index) => {
      const done = index < thresholds.length && elapsed >= thresholds[index]
      const current = !done && (index === 0 || elapsed >= thresholds[index - 1])
      step.dataset.state = done ? "done" : current ? "current" : "pending"
    })
  }

  thresholds() {
    const read = 8 + 4 * Math.max(this.filesValue, 1)
    const compose = read + 3 * Math.max(this.questionsValue, 1)
    return [read, compose]
  }
}
